// TrustBadge v4 (2026-07-02) — migrado a MercadoPago (procesador único D-1 + tienda + ML)

/**
 * Badge de confianza. Variants:
 *   - 'default' : caja grande con lista de métodos (Inicio cliente, Tienda)
 *   - 'compact' : pill chiquito con candado (header/footer)
 *   - 'inline'  : pill inline (Cuenta)
 */
export default function TrustBadge({ variant = 'default' }) {
  if (variant === 'compact') {
    return (
      <div className="trust-compact">
        <span className="trust-compact-lock">🔒</span>
        <span>Pago seguro con</span>
        <img src="/mp-logo-tight.svg" alt="MercadoPago" style={{ height: 22, verticalAlign: 'middle', marginLeft: 6 }} />
        <style>{cssCompact}</style>
      </div>
    )
  }
  if (variant === 'inline') {
    return (
      <div className="trust-inline">
        <span className="trust-inline-lock">🔒</span>
        <span>Pago seguro ·</span>
        <img src="/mp-logo-tight.svg" alt="MercadoPago" style={{ height: 20, verticalAlign: 'middle', margin: '-2px 6px' }} />
        <span>· SSL</span>
        <style>{cssInline}</style>
      </div>
    )
  }
  return (
    <div className="trust-default">
      <div className="trust-default-icon">
        <img src="/mp-logo-tight.svg" alt="MercadoPago" style={{ height: 32, display: 'block' }} />
      </div>
      <div className="trust-default-body">
        <div className="trust-default-title">🔒 Pago 100% seguro · Procesado por MercadoPago</div>
        <div className="trust-default-sub">
          Aceptamos tarjetas de crédito y débito (Visa, Mastercard, OCA, Cabal, AmEx),
          banca digital, Redpagos, Abitab, transferencia bancaria y cuotas sin recargo.<br/>
          Tus datos viajan con cifrado SSL · Limpack nunca ve los datos de tu tarjeta.
        </div>
      </div>
      <style>{cssDefault}</style>
    </div>
  )
}

const cssDefault = `
.trust-default {
  display: flex; align-items: center; gap: 16px;
  background: linear-gradient(135deg, rgba(0,168,181,.08), rgba(0,168,181,.04));
  border: 1px solid rgba(0,168,181,.22);
  border-radius: 14px; padding: 16px 18px;
}
.trust-default-icon {
  flex-shrink: 0;
  background: #fff;
  border-radius: 10px;
  padding: 6px 10px;
  border: 1px solid rgba(0,158,227,.25);
  display: flex; align-items: center; justify-content: center;
}
.trust-default-body { flex: 1; min-width: 0 }
.trust-default-title { font-size: 14px; font-weight: 800; color: var(--cl-text, #f1f5f9); }
.trust-default-sub { font-size: 12px; color: var(--cl-muted, #94a3b8); margin-top: 6px; line-height: 1.5 }
`

const cssCompact = `
.trust-compact {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 12px; background: rgba(255,255,255,.06);
  border-radius: 10px; font-size: 11px; color: rgba(255,255,255,.85);
}
.trust-compact strong { color: #fff; font-weight: 800 }
.trust-compact-lock { font-size: 12px }
`

const cssInline = `
.trust-inline {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 999px;
  background: #f0fdfa; border: 1px solid #99f6e4;
  font-size: 12px; font-weight: 600; color: #115e59;
  line-height: 1.2;
  white-space: nowrap;
}
.trust-inline strong { font-weight: 800; color: #0f4c4a }
.trust-inline-lock { font-size: 14px }
`
